import React, { useEffect } from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import logo from '../../assets/images/logo.png';

const Preloader = ({ onLoadingComplete }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      if (onLoadingComplete) onLoadingComplete();
    }, 2400);
    return () => clearTimeout(timer);
  }, [onLoadingComplete]);

  return (
    <PreloaderContainer
      initial={{ opacity: 1 }}
      exit={{ opacity: 0, y: '-100vh' }}
      transition={{ duration: 0.7, ease: [0.76, 0, 0.24, 1] }}
    >
      <GlowBg />
      <LoaderContent>
        <motion.img
          src={logo}
          alt="Prince Yadav"
          initial={{ scale: 0, opacity: 0, rotate: -10 }}
          animate={{ scale: 1, opacity: 1, rotate: 0 }}
          transition={{ duration: 0.6, type: 'spring', stiffness: 180, damping: 14 }}
          style={{
            width: 96,
            height: 96,
            objectFit: 'contain',
            marginBottom: '1.5rem',
            filter: 'brightness(1.5) drop-shadow(0 0 15px rgba(124, 58, 237, 0.5))'
          }}
        />
        <motion.div
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.45, duration: 0.4 }}
        >
          <NameText>PRINCE YADAV</NameText>
        </motion.div>
        <motion.div
          initial={{ opacity: 0, y: 8 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.65, duration: 0.35 }}
        >
          <TaglineText>Web Developer · Cybersecurity · HigenLabs</TaglineText>
        </motion.div>
        <LoadingBarWrapper>
          <motion.div
            initial={{ width: 0 }}
            animate={{ width: '100%' }}
            transition={{ duration: 2.0, ease: 'easeInOut', delay: 0.3 }}
            style={{
              height: '100%',
              background: 'linear-gradient(90deg, #7C3AED, #2563EB, #A78BFA)',
              borderRadius: '4px',
            }}
          />
        </LoadingBarWrapper>
      </LoaderContent>
    </PreloaderContainer>
  );
};

const PreloaderContainer = styled(motion.div)`
  position: fixed;
  inset: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #05050F;
  z-index: 9999;
  overflow: hidden;
`;

const LoaderContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
  position: relative;
  z-index: 2;
`;

const NameText = styled.h2`
  font-size: 1.5rem;
  font-weight: 700;
  letter-spacing: 0.25em;
  background: linear-gradient(135deg, #A78BFA, #7C3AED, #2563EB);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  margin: 0;
`;

const TaglineText = styled.p`
  font-size: 0.78rem;
  letter-spacing: 0.12em;
  color: rgba(203, 213, 225, 0.6);
  margin: 0.25rem 0 1.25rem;
`;

const LoadingBarWrapper = styled.div`
  width: 220px;
  height: 2px;
  background: rgba(255, 255, 255, 0.08);
  border-radius: 4px;
  overflow: hidden;
  margin-top: 0.5rem;
`;

const GlowBg = styled.div`
  position: absolute;
  width: 400px;
  height: 400px;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(124,58,237,0.15) 0%, transparent 70%);
  pointer-events: none;
  z-index: 1;
`;

export default Preloader;
